import React from "react";
import { Picker } from "@design-system/Picker/Picker.lib";

interface ConsolidationTableSelectOption<Value extends string> {
    label: string;
    value: Value;
}

interface ConsolidationTableSelectProps<Value extends string> {
    value: Value;
    options: Array<ConsolidationTableSelectOption<Value>>;
    onChange: (value: Value) => void;
}

export const ConsolidationTableSelect = <Value extends string>({
    value,
    options,
    onChange,
}: Readonly<ConsolidationTableSelectProps<Value>>): React.ReactElement => (
    <Picker.Select
        items={options}
        value={value}
        onValueChange={(nextValue) => nextValue && onChange(nextValue)}
        chevron="none"
    />
);
